const BreakPoints = {
    xs: 320,
    sm: 600,
    md: 900,
    lg: 1160,
    lgs: 1280,
    xl: 1720,
};

export default BreakPoints;
